/** The prompt line (docs/ux.md U-PRIN-02, §7): what to do now, from the turn machine. */
import { legalActions } from '@brig/rules-engine';
import type { Messages } from '../i18n/locales/en.ts';
import { hintsFor } from './hints.ts';
import { current } from './history.ts';
import { uiPhase } from './phase.ts';
import { shipsToMove } from './turn.ts';
import { liveSquadron } from './turnMachine.ts';
import type { TurnSnapshot } from './useTurn.ts';

/** U-PRIN-02: the one sentence that says what to do now. */
export function promptKey(snapshot: TurnSnapshot): `game.prompt.${keyof Messages['game']['prompt']}` {
  const state = current(snapshot.context.history);
  switch (uiPhase(snapshot)) {
    case 'handover':
      return 'game.prompt.handover';
    case 'muster':
      if (snapshot.context.fire) return 'game.prompt.fire';
      if (snapshot.context.portMove) return 'game.prompt.portMove';
      return liveSquadron(snapshot.context).length > 0
        ? 'game.prompt.musterChosen'
        : 'game.prompt.musterEmpty';
    case 'wind':
      return 'game.prompt.wind';
    case 'replay':
      return 'game.prompt.replay';
    case 'waiting':
      return 'game.prompt.waiting';
    case 'over':
      return 'game.prompt.over';
    case 'battle': {
      if (snapshot.matches({ battle: 'confirmingEnd' })) return 'game.prompt.endSummary';
      if (snapshot.context.fire) return 'game.prompt.fire';
      if (snapshot.context.portMove) return 'game.prompt.portMove';
      const sel = snapshot.context.selected;
      if (sel && hintsFor(state, legalActions(state, state.turn.side), sel).moveCells.size > 0) {
        return 'game.prompt.battleReach';
      }
      return shipsToMove(state).length > 0 ? 'game.prompt.battleMove' : 'game.prompt.battleIdle';
    }
  }
}
